import {
  EXPORT_ROOM_BOOKING_FAILURE,
  EXPORT_ROOM_BOOKING_REQUEST,
  EXPORT_ROOM_BOOKING_SUCCESS,
  GET_ALL_RESERVATION_LIST_FAILURE,
  GET_ALL_RESERVATION_LIST_REQUEST,
  GET_ALL_RESERVATION_LIST_SUCCESS,
  GET_BYID_ROOM_BOOKING_FAILURE,
  GET_BYID_ROOM_BOOKING_REQUEST,
  GET_BYID_ROOM_BOOKING_SUCCESS,
  GET_RESERVATION_LIST_EXPORT_FAILURE,
  GET_RESERVATION_LIST_EXPORT_REQUEST,
  GET_RESERVATION_LIST_EXPORT_SUCCESS,
  GET_ROOM_BOOKING_LIST_FAILURE,
  GET_ROOM_BOOKING_LIST_REQUEST,
  GET_ROOM_BOOKING_LIST_SUCCESS,
  PATCH_ROOM_BOOKING_FAILURE,
  PATCH_ROOM_BOOKING_REQUEST,
  PATCH_ROOM_BOOKING_SUCCESS,
  POST_RECORD_PAYMENT_FAILURE,
  POST_RECORD_PAYMENT_REQUEST,
  POST_RECORD_PAYMENT_SUCCESS,
  POST_ROOM_BOOKING_FAILURE,
  POST_ROOM_BOOKING_REQUEST,
  POST_ROOM_BOOKING_SUCCESS,
  PUT_ROOM_BOOKING_DETAILS_FAILURE,
  PUT_ROOM_BOOKING_DETAILS_REQUEST,
  PUT_ROOM_BOOKING_DETAILS_SUCCESS,
  PUT_ROOM_REASSIGN_FAILURE,
  PUT_ROOM_REASSIGN_REQUEST,
  PUT_ROOM_REASSIGN_SUCCESS,
} from "../../../Utils/Constant";

// Get The List Of Reservation Check-in And Check-out
export const roomReservationRequest = (payload) => {
  return {
    type: GET_ROOM_BOOKING_LIST_REQUEST,
    payload: payload,
  };
};

export const roomReservationSuccess = (data) => {
  return {
    type: GET_ROOM_BOOKING_LIST_SUCCESS,
    payload: data,
  };
};

export const roomReservationFailure = (error) => {
  return {
    type: GET_ROOM_BOOKING_LIST_FAILURE,
    payload: error,
  };
};

// Add The Booking The  Room
export const addRoomReservationRequest = (payload) => {
  return {
    type: POST_ROOM_BOOKING_REQUEST,
    payload: payload,
  };
};

export const addRoomReservationSuccess = (data) => {
  return {
    type: POST_ROOM_BOOKING_SUCCESS,
    payload: data,
  };
};

export const addRoomReservationFailure = (error) => {
  return {
    type: POST_ROOM_BOOKING_FAILURE,
    payload: error,
  };
};

// Reassign Room
export const putRoomRessignRequest = (payload) => {
  return {
    type: PUT_ROOM_REASSIGN_REQUEST,
    payload,
  };
};

export const putRoomRessignSuccess = (data) => {
  return {
    type: PUT_ROOM_REASSIGN_SUCCESS,
    payload: data,
  };
};

export const putRoomRessignFailure = (error) => {
  return {
    type: PUT_ROOM_REASSIGN_FAILURE,
    payload: error,
  };
};

// Edit The Booking The  Room
export const patchRoomReservationRequest = (payload) => {
  return {
    type: PATCH_ROOM_BOOKING_REQUEST,
    payload,
  };
};

export const patchRoomReservationSuccess = (data) => {
  return {
    type: PATCH_ROOM_BOOKING_SUCCESS,
    payload: data,
  };
};

export const patchRoomReservationFailure = (error) => {
  return {
    type: PATCH_ROOM_BOOKING_FAILURE,
    payload: error,
  };
};

// GetBy ID room The Booking The  Room
export const getByIdRoomReservationRequest = (payload) => {
  return {
    type: GET_BYID_ROOM_BOOKING_REQUEST,
    payload,
  };
};

export const getByIdRoomReservationSuccess = (data) => {
  return {
    type: GET_BYID_ROOM_BOOKING_SUCCESS,
    payload: data,
  };
};

export const getByIdRoomReservationFailure = (error) => {
  return {
    type: GET_BYID_ROOM_BOOKING_FAILURE,
    payload: error,
  };
};

// exprot Booking
export const exportRoomReservationRequest = (payload) => {
  return {
    type: EXPORT_ROOM_BOOKING_REQUEST,
    payload: payload,
  };
};

export const exporRoomReservationSuccess = (data) => {
  return {
    type: EXPORT_ROOM_BOOKING_SUCCESS,
    payload: data,
  };
};

export const exportRoomReservationFailure = (error) => {
  return {
    type: EXPORT_ROOM_BOOKING_FAILURE,
    payload: error,
  };
};

// EXPORT FEATURE

export const getReservationListExport = (payload) => {
  return {
    type: GET_RESERVATION_LIST_EXPORT_REQUEST,
    payload,
  };
};

export const getReservationListExportSuccess = (payload) => {
  return {
    type: GET_RESERVATION_LIST_EXPORT_SUCCESS,
    payload,
  };
};

export const getReservationListExportFailure = (payload) => {
  return {
    type: GET_RESERVATION_LIST_EXPORT_FAILURE,
    payload,
  };
};

// Get All Reservation List Details
export const getAllRoomReservationListRequest = (payload) => {
  return {
    type: GET_ALL_RESERVATION_LIST_REQUEST,
    payload,
  };
};

export const getAllRoomReservationListSuccess = (data) => {
  return {
    type: GET_ALL_RESERVATION_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllRoomReservationListFailure = (error) => {
  return {
    type: GET_ALL_RESERVATION_LIST_FAILURE,
    payload: error,
  };
};

// Update Room Bookinng Details
export const updateRoomBookiingDetailsRequest = (payload) => {
  return {
    type: PATCH_ROOM_BOOKING_REQUEST,
    payload,
  };
};

export const updateRoomBookiingDetailsSuccess = (data) => {
  return {
    type: PUT_ROOM_BOOKING_DETAILS_SUCCESS,
    payload: data,
  };
};

export const updateRoomBookiingDetailsFailure = (error) => {
  return {
    type: PUT_ROOM_BOOKING_DETAILS_FAILURE,
    payload: error,
  };
};

// Payment update
export const postRecordPaymentRequest = (payload) => {
  return {
    type: POST_RECORD_PAYMENT_REQUEST,
    payload: payload,
  };
};

export const postRecordPaymentSuccess = (data) => {
  return {
    type: POST_RECORD_PAYMENT_SUCCESS,
    payload: data,
  };
};

export const postRecordPaymentFailure = (error) => {
  return {
    type: POST_RECORD_PAYMENT_FAILURE,
    payload: error,
  };
};